import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'NGNlMmEyMTI0YTY1YWY3YWEwOTA2NDY1OWNhOTA0NzA=',
  'Tenant-Access-Key': 'YSPNpF0a3lAlLg',
};

export const BASE_URL = 'https://immersive-game-india.confirmu.com';

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});

